import { NitroLoading, NitroModal, NitroParagraph } from 'nitro-components';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import getIsAuth0Authenticated from '../../utils/auth0/is-authenticated';
import * as loginActions from '../../auth/actions';
import { pushData, pushGAAction } from '../../utils/gtm';
import * as routes from '../../routes/const';
import {refreshAccessToken} from '../../utils/auth0/access-token';
import { newJwtTokenProvider } from '../login/jwt-token-provider';

const ModalContent = styled.div`
  width: 100%;
`;

class Auth0Redirect extends Component {
  constructor() {
    super();
    this.state = {
      authCheckDone: false
    };

    this.toggleAuthState = this.toggleAuthState.bind(this);
  }

  componentWillMount() {
    getIsAuth0Authenticated().then(this.toggleAuthState);
  }

  componentWillUpdate(nextProps) {
    const { isAuthenticated, userMustAcceptTerms } = nextProps.auth;
    const { router } = this.context;
    if (
      isAuthenticated &&
      !userMustAcceptTerms &&
      window.location.pathname.includes(routes.LOGIN)
    )
      router.push('/');
  }

  handleLoginSuccess() {
    const { userMustAcceptTerms, refId } = this.props.auth;

    pushData({
      userId: refId
    });

    if (userMustAcceptTerms) {
      pushGAAction('AUTH', 'show_terms_n_cond');
    } else {
      pushGAAction('AUTH', 'login_successfull', '', {
        login_date: new Date().toISOString()
      });

      this.redirectAuthenticatedUser();
    }
  }

  redirectAuthenticatedUser() {
    const { router } = this.context;
    const { returnUrl } = this.props.location.query;

    if (returnUrl && returnUrl !== '') {
      return window.location.assign(returnUrl);
    }

    router.push('/');

    return undefined;
  }

  async toggleAuthState(isAuth0Authenticated) {
    const { isAuthenticated } = this.props.auth;
    const {
      legacyLogin,
      loginExternal,
      displayLogoutWarningDialog,
      displayLogoutDialog
    } = this.props.actions;

    const onLegacyLogin = window.location.pathname.includes(routes.LOGIN);
    const { external_code: externalCode } = this.props.location.query;
    const doExternalLogin = !!externalCode;

    if (isAuth0Authenticated) {
      newJwtTokenProvider({
        // Called when the token could not be decoded
        onErrorDecode: displayLogoutDialog,
        // Called when there was an error parsing the expiry time
        onErrorParseExpiry: displayLogoutDialog,
        // Called if the token is expired
        onTokenExpired: displayLogoutDialog,
        // Called if the token is within the expiry warning period
        // Currently we do not provide warning functionality
        onTokenExpiryWarning: displayLogoutWarningDialog
      });
      await refreshAccessToken();

      if (isAuthenticated) {
        if (onLegacyLogin) {
          this.redirectAuthenticatedUser();
        }
      } else {
        try {
          await legacyLogin();
          this.handleLoginSuccess();
        } catch (err) {
          console.log('err', err); // eslint-disable-line no-console
        }
      }
    } else if (!isAuthenticated && doExternalLogin) {
      try {
        await loginExternal(externalCode);
        this.handleLoginSuccess();
      } catch (err) {
        console.log('err', err); // eslint-disable-line no-console
      }
    }

    this.setState({ authCheckDone: true });
  }

  render() {
    const { authCheckDone } = this.state;
    const { actions, auth } = this.props;
    const {
      userMustAcceptTerms = true,
      connectionError = false,
      isAuthenticated = false
    } = auth;
    const { acceptTerms, logout } = actions;

    if (
      authCheckDone &&
      isAuthenticated &&
      !window.location.pathname.includes(routes.CompleteAuth0Logout) &&
      userMustAcceptTerms
    ) {
      return (
        <NitroModal
          title="Terms &amp; Conditions"
          action={() => {
            acceptTerms();
          }}
          actionLabel="Agree"
          cancelAction={logout}
          cancelLabel="Disagree"
          isOpen={userMustAcceptTerms && !connectionError}
          close={logout}
          messageFlexDirection="row">
          <ModalContent>
            <NitroParagraph align="center">
              <a href="legal/TermsAndConditions.pdf" target="_blank">
                Download the Online Portal Terms and Conditions of Use
              </a>
            </NitroParagraph>

            <NitroParagraph align="center">
              By clicking "Agree" below, I agree that I have downloaded and
              read, and agree to, the Online Portal Terms and Conditions of Use.
            </NitroParagraph>
          </ModalContent>
        </NitroModal>
      );
    } else if (authCheckDone) {
      return this.props.children;
    }

    return <NitroLoading center />;
  }
}

Auth0Redirect.defaultProps = {
  auth: {}
};

Auth0Redirect.propTypes = {
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object
};

Auth0Redirect.contextTypes = {
  router: PropTypes.object
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth0Redirect);



// WEBPACK FOOTER //
// ./src/features/legacy-login-sync/index.js